const getSections = () => {
  const data = JSON.parse(window.localStorage.getItem('sections'))
  if (!data) return

  data.forEach((item) => {
    let parentName
    if (item.parent) {
      const parent = data.find((subItem) => item.parent.includes(subItem.id))
      if (parent) parentName = parent.title
      item.title = `${parentName} > ${item.title}`
    }
  })

  const list = data.map((item) => {
    return {
      value: item.id,
      name: item.title
    }
  })

  list.sort((a, b) => {
    return a.name > b.name ? 1 : a.name < b.name ? -1 : 0
  })

  return list
}

export { getSections }
